import React, { useContext } from 'react'

import { Button, Dialog } from '@clientbase/clientbase-library'
import { useRouter } from 'next/router'

import { FeatureTabs } from 'utils/tabs'

import { NegativationContext } from '../../context'
import { FormNegativationContext } from '../context'

interface ConfirmationProps {
  handleCloseModal: () => void
}

const Confirmation: React.FC<ConfirmationProps> = ({ handleCloseModal }) => {
  const { confirmationDialog, updateConfirmationDialog } = useContext(
    FormNegativationContext
  )

  // O formulário também abre pelo "Negativar" do detalhe da cobrança, que vive
  // em lugares sem NegativationContext (e sem o Detail renderizado). Só a aba
  // Negativação abre o detalhe no lugar; fora dela, navega até ela.
  const { updateModalDetail } = useContext(NegativationContext)
  const { query, push } = useRouter()

  const closeConfirmationDialog = () => {
    updateConfirmationDialog({ open: false, uuid: '' })
  }

  const handleOpenDetail = () => {
    const uuid = confirmationDialog.uuid

    updateConfirmationDialog({ open: false, uuid: '' })
    handleCloseModal()

    if (query?.tab === FeatureTabs.NEGATIVATION && updateModalDetail) {
      updateModalDetail({ open: true, uuid })
    } else {
      push(`/cobrancas?tab=${FeatureTabs.NEGATIVATION}&detail=${uuid}`)
    }
  }

  return (
    <Dialog
      icon="checkCircle"
      title="Negativação solicitada"
      description="Nossa equipe ja está analisando a sua solicitação. Seu cliente será notificado via e-mail após a aprovação da negativação"
      isOpenDialog={confirmationDialog.open}
      setIsOpenDialog={closeConfirmationDialog}
    >
      <Button onClick={handleOpenDetail}>Detalhes</Button>
    </Dialog>
  )
}

export default Confirmation
